import { array, mixed } from 'yup';
import { Channel } from 'basics/enums/maya.enums';

const useCepTemplateSelectorFiltersSchema = () => {
  return {
    channel: array()
      .of(mixed<Channel>().oneOf(Object.values(Channel))),
  };
};

export default useCepTemplateSelectorFiltersSchema;
